import React, {createContext} from 'react';
import {FormGroup, Tag, Tooltip} from '@blueprintjs/core';
import styled, {css} from 'styled-components';

const GroupHeaderExtraContext = createContext(null);
const CollectionGroupContext = createContext(null);


const sfVars = css`
    --sf-vertical-gap: 0.25em;
    --sf-horizontal-gap: 0.5em;
    --sf-group-padding: 12px;
    --sf-group-margin: 0.75em;
    --sf-group-label-color: inherit;
    --sf-group-label-size: inherit;
    --sf-label-color: inherit;
    --sf-label-size: inherit;
    --sf-label-weight: 600;
    --sf-border-radius: 20px;
    --sf-group-background: white;
    --sf-group-shadow: 0 0 0 1px rgba(17, 20, 24, 0.15), 0 0 0 rgba(17, 20, 24, 0), 0 1px 1px rgba(17, 20, 24, 0.2);
    --sf-text-align: left;
`;

const StyledFormGroup = styled(FormGroup)`
    label[class*="bp"][class*="-label"] {
        color: var(--sf-label-color);
        font-size: var(--sf-label-size);
        font-weight: var(--sf-label-weight);
    }
`;

const RoundedInputWrap = styled.div`
    & [class*="bp"][class*="-input-group"],
    & [class*="bp"][class*="-input-group"] > [class*="bp"][class*="-input"],
    & textarea[class*="bp"][class*="-input"] {
        border-radius: var(--sf-border-radius) !important;
    }
    & [class*="bp"][class*="-input"],
    & textarea[class*="bp"][class*="-input"] {
        text-align: var(--sf-text-align);
    }
`;

const errorMessage = (e) => {
    if (e.keyword === 'errorMessage') return e.message;
    const prop = e.instancePath ? e.instancePath.split('/').pop() : null;
    if (prop && e.keyword === 'required') return `"${prop}" is required`;
    if (prop) return `"${prop}" ${e.message}`;
    return e.message;
};

const ErrorTag = ({errors, onClick}) => {
    if (!errors || !errors.length) return null;
    const count = errors.length;
    if (count === 1) {
        return <Tag intent="danger" minimal round interactive={!!onClick} onClick={onClick}>{errorMessage(errors[0])}</Tag>;
    }
    const tip = errors.slice(0, 3).map(e => errorMessage(e)).join('\n') + (count > 3 ? `\n... and ${count - 3} more` : '');
    return (
        <Tooltip content={<span style={{whiteSpace: 'pre-line'}}>{tip}</span>} placement="top">
            <Tag intent="danger" minimal round interactive onClick={onClick}>{count} errors</Tag>
        </Tooltip>
    );
};

export {sfVars, StyledFormGroup, RoundedInputWrap, GroupHeaderExtraContext, CollectionGroupContext, ErrorTag};
